window.MenuHoverTimer = 300;//Menu hover delay time (ms)
window.MenuHeaderId = 0;//Menu hover delay time (ms)
//////Layout use common script start--------------------------------
var getSubString = function (getDecodeString, maxNumber) {
	var split = getDecodeString.split(" ");
	var totalLong = 0;
	var subString = "";

	for (var i = 0; i < split.length; i++) {
		var getLong = split[i].length;

		totalLong = totalLong + getLong;

		if (totalLong > maxNumber) {
			return subString;
		} else {
			subString = subString + split[i] + " ";
		}
	}
	return subString;
}

var GetLimitSubString = {

	//是否包含中文
	hasZh: function (str) {
		for (var i = 0; i < str.length; i++) {
			if (str.charCodeAt(i) > 255) //如果是漢字，則字符串長度加2
				return true;
			return false;
		}
	},
	//重新計算長度，中文+2，英文+1
	getlen: function (str) {
		var strlen = 0;
		for (var i = 0; i < str.length; i++) {
			if (str.charCodeAt(i) > 255) //如果是漢字，則字符串長度加2
				strlen += 2;
			else
				strlen++;
		}
		return strlen;
	},
	//限制中文長度
	limitlTwHk: function (str, maxNumber) {
		if (!str) {
			return str;
		}
		var needToAdd = false;
		var result = "";
		var strlen = 0;
		for (var i = 0; i < str.length; i++) {
			if (str.charCodeAt(i) > 255) //如果是漢字，則字符串長度加2
				strlen += 2;
			else
				strlen++;

			result += str.substr(i, 1);
			if (strlen >= maxNumber) {
				needToAdd = true;
				break;
			}
		}
		if (needToAdd) {
			result = result + '...';
		}
		return result;
	},
	//限制中文GIGABYTE全大寫
	limitTwHkGIGABYTE: function (str, ciKeyword) {
		var tempStr = str;
		for (var k = 0; k < ciKeyword.length; k++) {
			if (tempStr.toLowerCase().indexOf(ciKeyword[k]) > -1) {
				//var tempReg=new RegExp(ciKeyword[k],"g");   //加上"g"為全部取代
				//tempStr=tempStr.replace(tempReg ,ciKeyword[k].toUpperCase());  //取代為CI全大寫
				var beginIndex = tempStr.toLowerCase().indexOf(ciKeyword[k]);
				tempStr =
					tempStr.substring(0, beginIndex) //頭
					+ tempStr.substring(beginIndex, beginIndex + ciKeyword[k].length).toUpperCase() //符合字串
					+ tempStr.substring(beginIndex + ciKeyword[k].length, tempStr.length); //尾
			}
		}
		str = tempStr;
		return str;
	},
	//限制英文長度
	limitEn: function (str, maxNumber) {
		if (!str) {
			return str;
		}
		
		var split = str.split(" ");
		var totalLong = 0;
		var subString = "";
		if (str.match(/[\u4e00-\u9fa5]/g)) {
			subString = this.limitlTwHk(str, maxNumber);
			if (subString.length) {
				return subString;
			}
		}

		var ciKeyword = ['GIGABYTE', 'AORUS'];

		for (var i = 0; i < split.length; i++) {
			var getLong = split[i].length;

			//限制GIGABYTE AORUS全大寫
			for (var k = 0; k < ciKeyword.length; k++) {
				if (split[i].indexOf(ciKeyword[i]) > -1) {
					split[i] = ciKeyword[i].toUpperCase();
				}
			}

			totalLong = totalLong + getLong;
			if (i !== split.length -1 ) {
				totalLong += 1;
			}
			if (totalLong > maxNumber) {
				if (str.length > maxNumber) {
					subString = subString.substring(0, subString.length - 1);
					subString = subString + '...';
				}
				return subString;
			} else {
				subString = subString + split[i];
				if (i < split.length-1) {
					subString = subString + " ";
				}
			}
		}
		return subString;
	}
}

var fixLtRonRTLForSearch = function (inputId) {
	if (window.isRTL)//若存在代表為首頁先行設定cookie
	{
		//選單
		if ($('.ui-menu-item').is(':visible')) {
			$(".ui-menu-item").css("direction", "ltr");
		} else {
			//setTimeout($(".ui-menu-item").css("direction", "ltr"), 50);
			$(".ui-menu-item").ready(function () {
				$(".ui-menu-item").css("direction", "ltr");
			});
		}
		//input 區塊
		if (typeof (inputId) !== 'undefined') {
			$('#' + inputId).css({ 'direction': 'ltr', 'text-align': 'right' });
		}
	}
}

var setSnsButtonMoreSlide = function () {

	$('body').click(function (event) {
		var target = $(event.target);
		if ($('.sns-slider-Content').length > 0) {
			if ((target.parents(".social-btn-more").length > 0 || target.hasClass('social-btn-more')) && $('.sns-slider-Content').css("display") === "none") {
				$('.sns-slider-Content').show('slide', { direction: 'down' }, 500);
			} else {
				$('.sns-slider-Content').hide('slide', { direction: 'down' }, 500);
			}
		}
	});
}

var removeExistArrayJson = function (productJson, ck) {
	var result = [];
	for (var i = 0; i < productJson.length; i++) {
		if (productJson[i].class_key !== ck) {
			result.push(productJson[i]);
		}
	}
	return result;
}

//Global CN 強制轉Https update By Cody.Yang 2018/07/19
var checRredirectHttps = function (url) {

	var result = 'http:';

	result = (url === 'www.gigabyte.com' || url === 'www.gigabyte.cn') && location.protocol === 'https:'
		? 'https:'
		: 'http:';

	return result;
}

function RWDDetactive() {
	return false;
	var BrowsweWidth = $(window).width();
	if (BrowsweWidth + 17 > RwdWid) {
		if (BrowsweWidth > 1450) {
			BrowsweWidth = 1450;
		}
		$("body").css("font-size", (BrowsweWidth / 100) + "px");
	} else {
		$("body").css("font-size", "14.5px");
	}
};

function setCookie(isRwd) {
	var d = new Date();
	//d.setTime(d.getTime() + (1 * 24 * 60 * 60 * 1000));
	d.setTime(d.getTime() + (1 * 30 * 60 * 1000));
	//d.setTime(d.getTime() - 1);刪除cookie
	var expires = "expires=" + d.toGMTString();
	//document.cookie = "isRwd=true" + "; " + expires + ';domain=' + "@Global.WebSiteUrl" + '; path=/';
	document.cookie = "isRwd=" + isRwd + "; " + expires + ';domain=' + "@Global.WebSiteUrl" + '; path=/';
	location.reload();
}

function getRwdCookie() {
	var cookie = document.cookie;
	if (cookie.indexOf('isRwd') > -1) {

		var cookies = cookie.split(';');
		for (var i = 0; i < cookies.length; i++) {
			if (cookies[i].indexOf('isRwd') > -1) {
				var value = cookies[i].split('=');
				if (value[1] === "false") {
					$(".topBg").removeClass("Rwd");
				} else {
					$(".topBg").addClass("Rwd");
				}
			}
		}
	}
}

var FixedMaterialIcon = function () {
	//Remove all material-icons and use SVG
	//setTimeout(FixedMaterialIcon, 500);
};

function SetContentPadding() {
	var headerHeight = $("#header-bar").children(".container-header").height();
	var FooterHeight = $("footer").height();
	if (!$("foot").hasClass("new-footer")) {		
		$("#PageMainContent").css("min-height", ($(window).height() - headerHeight - FooterHeight) + 50 + 'px');//new version 註解by neal 就version 保留
	}
}

String.format = function () {
	var s = arguments[0];
	for (var i = 0; i < arguments.length - 1; i++) {
		var reg = new RegExp("\\{" + i + "\\}", "gm");
		s = s.replace(reg, arguments[i + 1]);
	}
	return s;
}

var responsiveFontSize = function () {
	/* Replace icon_arrorw01.png for title arrow by Paul Lu 20140912 end */
	var customerMinFont = 14.5;
	if (navigator.userAgent.match("MSIE 8")) {
		customerMinFont = 15;
	}

	$('body').flowtype({
		minimum: 1920,
		maximum: 3840,
		minFont: customerMinFont,
		fontRatio: 145
	});
};
//////Layout use common script end----------------------------------




//////Layout use Header script start--------------------------------
//設定所有menu 相關內容
/*
var SettingMenu = function () {
	//設定menu header 至頂高度
	//SettingMenuBarHeight();
	SettingMenuShow();
	SettingSearch();
	scrollMobileMenu();
	//settingMenuB2BCookie();
	settingMenuB2BRwdPadding();
	//MWC2020Menu();
	//SettingMenuBarByScroll();
}*/



//////Layout use Footer script start--------------------------------
var setFooterInfoPadding = function () {
	if (!CheckUseRWDsizeNow()) {
		var getFooter = $(".footer-info-area");

		//調整FOOTER 左下角各ITEM 寬度
		var getPaddingBottomMax = 0;
		getFooter.children('.footer-info').find('li').each(function () {
			if (parseInt($(this).css("padding-bottom")) > getPaddingBottomMax) {
				getPaddingBottomMax = parseInt($(this).css("padding-bottom"));
			}
		});
		getFooter.children('.footer-info').find('li').css("padding-bottom", getPaddingBottomMax);

		getFooter.ready(function () {
			if ($(".footer-info").length > 4) {
				var getfooterWidth = parseInt(getFooter.width());
				var getFooterInfo = 0;

				getFooter.children('.footer-info').each(function () {

					getFooterInfo = getFooterInfo + parseInt($(this).outerWidth());
				});

				var getMarginNum = parseInt((getfooterWidth - getFooterInfo) / ($(".footer-info").length)) - 10;
				getMarginNum = getMarginNum > 6 ? getMarginNum : 6;

				//Fix ReSize GMicroSite footer error
				if (!CheckUseRWDsizeNow()) {
					if (window.isRTL) {
						$('.footer-info').css("margin-left", getMarginNum);
					}
					else {
						$('.footer-info').css("margin-right", getMarginNum);
					}
				}
			}
		});
	} else {
		$('.sns-slider-Content').css("display", "none");
	}
}


function fixSnsSliderMenu() {
	var snsdivWidth = $('.footer-info-sns');
	var getWidth = 0;
	$.each(snsdivWidth, function (i, snsdivWidth) {
		$('.social-btn', snsdivWidth).each(function () {
			getWidth = getWidth + parseInt($(this).outerWidth(true));
		});
	});
	var snsLocalItem = $('.sns-slider-Content');
	snsLocalItem.css('width', getWidth);
	snsLocalItem.css('top', 0 - parseInt(snsLocalItem.outerHeight(true)));
	//$('.sns-slider-Content').css('padding','0.5%');
	getWidth = 0;
}

var MWC2020Menu = function () {
	var menuHeader = $("li.menu-header-43");
	if (menuHeader.length === 1 && IsDuringEventTime()) {
		var isUseUnderRWD = CheckUseRWDsizeNow();
		if (menuHeader.find("span.mwc2020").length === 0) {
			var span = $("<span></span>");
			span.addClass("mwc2020");
			var spanInner = $("<span></span>").addClass("inner");
			var img = $("<img />");
			img.addClass("IconImg");
			img.attr("src", "/Images/Event/2020/MWC/MWCBadge.svg");
			//img.attr("src", "/FakePath/MWCBadge.svg");
			spanInner.append(img);
			span.append(spanInner);
			menuHeader.children("a").append(span);
		}
	}
}
//////Layout use Footer script end----------------------------------